import * as _ from 'lodash';
import {CHOOSE_SUITABLE_EVENT} from "../actions/action";
import {put, select, takeEvery} from "redux-saga/effects";
import {AnyAction} from "redux";
import {getEnergyMix} from "../reducers/getEnergyMix";
import {getCostPerMw} from "../reducers/outputs/costPerMw";
import {getEnergyOutput} from "../reducers/outputs/energyOutput";
import {getEnvironmentalImpact} from "../reducers/outputs/environmentalImpact";
import {getMiniGames, IMiniGame} from "../../data/data";
import {setEventID} from "../actions/events";



/**
 * handle events
 */
export default function* handleEvents()
{
    yield takeEvery(CHOOSE_SUITABLE_EVENT, onRequestEvent);
}


/**
 * choose a suitable event based on game properties
 * @param {AnyAction} action
 */
function* onRequestEvent(action: AnyAction)
{
    //  get KPIs

    const energy_mix: number = yield select(getEnergyMix);
    const cost_per_mw: number = yield select(getCostPerMw);
    const energy_output: number = yield select(getEnergyOutput);
    const environmental: number = yield select(getEnvironmentalImpact);

    const kpis = {energy_mix, cost: cost_per_mw, energy_output, environmental};

    //  get all events

    const events: IMiniGame[] = getMiniGames();

    // console.group('onRequestEvent');
    // console.log('energy_mix', energy_mix);
    // console.log('cost_efficiency', cost_efficiency);
    // console.log('energy_output', energy_output);
    // console.log('environmental', environmental);
    // console.log('events', events);

    //  find the first event whose requirements fit the current game state

    // const relevant_events: IEvent[] = _.filter(events, event =>
    // {
    //     return _.every(event.requirements, (range: number[], kpi: string) =>
    //     {
    //         const kpi_value: number = kpis[kpi];
    //
    //         return kpi_value >= range[0] && kpi_value <= range[1];
    //     })
    // });

    // console.log('relevant_events', relevant_events);

    const event: IMiniGame = _.sample(events);

    // console.log('event', event);
    // console.groupEnd();

    //  add more score

    yield put(setEventID(event.id));
}



// WEBPACK FOOTER //
// ./src/ts/store/sagas/handleEvents.ts